<template>
  <div>
    <y-periodselector
      @period="periodselected"
      :iscierre="true"
      :period="period"
    ></y-periodselector>
    <div class="field is-grouped">
      <div class="control">
        <div class="select">
          <select v-model="ccosto" @change="changeccosto">
            <option
              v-for="(costo, index) in ccostos"
              :key="index"
              :value="costo.codigo"
            >
              {{ costo.codigo }} {{ costo.nombre }}
            </option>
          </select>
        </div>
      </div>
      <div class="control">
        <button type="submit" class="button is-link" @click="search">
          <span class="icon is-small">
            <span class="material-icons">search</span>
          </span>
          <span>Buscar</span>
        </button>
      </div>
      <div class="control">
        <button type="submit" class="button is-light" @click="imprimir">
          <span class="icon is-small">
            <span class="material-icons">print</span>
          </span>
          <span>Imprimir</span>
        </button>
      </div>
      <div class="control">
        <button type="submit" class="button is-light" @click="preparar">
          <span class="icon is-small">
            <span class="material-icons">functions</span>
          </span>
          <span>Calcular</span>
        </button>
      </div>
      <div class="control">
        <button
          type="submit"
          class="button is-light"
          v-if="totales.todas.list.length !== 0"
          @click="descargarBalance"
        >
          <span class="icon is-small">
            <span class="material-icons">archive</span>
          </span>
          <span>Descargar</span>
        </button>
      </div>
    </div>
    <div id="printbalance" class="table-container">
      <span style="font-size: 20px">
        <strong>{{ empresa.nombrec }}</strong>
        <small>
          <strong
            >{{ empresa.nit | textnumber()
            }}{{ empresa.nit | dverif() }}</strong
          >
        </small>
        <small style="font-size: 70%; color: #7a7a7a">{{
          empresa.nombre
        }}</small>
        <br />
        Balance de cuenta {{ periodo | periodo()
        }}{{ ccosto !== "" ? `, Centro de Costos ${nccosto}` : "" }}
      </span>
      <table style="width: 100%; font-size: 14px" class="fontMono">
        <tr style="background-color: #f3f3f3">
          <td
            style="
              border-top: 1px solid #dbdbdb;
              border-bottom: 1px solid #dbdbdb;
              padding: 2px;
            "
          >
            <strong>Código</strong>
          </td>
          <td
            style="
              border-top: 1px solid #dbdbdb;
              border-bottom: 1px solid #dbdbdb;
              padding: 2px;
            "
          >
            <strong>Nombre</strong>
          </td>
          <td
            style="
              border-top: 1px solid #dbdbdb;
              border-bottom: 1px solid #dbdbdb;
              padding: 2px;
              text-align: right;
            "
          >
            <strong>S Inicial</strong>
          </td>
          <td
            style="
              border-top: 1px solid #dbdbdb;
              border-bottom: 1px solid #dbdbdb;
              padding: 2px;
              text-align: right;
            "
          >
            <strong>Debito</strong>
          </td>
          <td
            style="
              border-top: 1px solid #dbdbdb;
              border-bottom: 1px solid #dbdbdb;
              padding: 2px;
              text-align: right;
            "
          >
            <strong>Credito</strong>
          </td>
          <td
            style="
              border-top: 1px solid #dbdbdb;
              border-bottom: 1px solid #dbdbdb;
              padding: 2px;
              text-align: right;
            "
          >
            <strong>S Final</strong>
          </td>
        </tr>
        <tr v-for="(cuenta, index) in totales.todas.list" :key="index">
          <td style="padding: 2px" :style="styleTr(cuenta)">{{ cuenta }}</td>
          <td style="padding: 2px" :style="styleTr(cuenta)">
            {{ totales[totales.todas[cuenta]][cuenta].nombre }}
          </td>
          <td style="padding: 2px; text-align: right" :style="styleTr(cuenta)">
            {{ totales[totales.todas[cuenta]][cuenta].sinicial | number(2) }}
          </td>
          <td
            style="padding: 2px 2px 2px 8px; text-align: right"
            :style="styleTr(cuenta, 'debito')"
            @mouseover="hovercuenta(cuenta, 'debito')"
            @mouseleave="leavecuenta"
            @click="auxiliar(cuenta, 'movimiento')"
          >
            {{ totales[totales.todas[cuenta]][cuenta].debito | number(2) }}
          </td>
          <td
            style="padding: 2px 2px 2px 8px; text-align: right"
            :style="styleTr(cuenta, 'credito')"
            @mouseover="hovercuenta(cuenta, 'credito')"
            @mouseleave="leavecuenta"
            @click="auxiliar(cuenta, 'movimiento')"
          >
            {{ totales[totales.todas[cuenta]][cuenta].credito | number(2) }}
          </td>
          <td
            style="padding: 2px 2px 2px 8px; text-align: right"
            :style="styleTr(cuenta, 'sfinal')"
            @mouseover="hovercuenta(cuenta, 'sfinal')"
            @mouseleave="leavecuenta"
            @click="auxiliar(cuenta, 'saldo')"
          >
            {{ totales[totales.todas[cuenta]][cuenta].sfinal | number(2) }}
          </td>
        </tr>
        <tr style="background-color: #f3f3f3">
          <td
            style="
              border-top: 1px solid #dbdbdb;
              border-bottom: 1px solid #dbdbdb;
              padding: 2px;
            "
          >
            <strong>T</strong>
          </td>
          <td
            style="
              border-top: 1px solid #dbdbdb;
              border-bottom: 1px solid #dbdbdb;
              padding: 2px;
            "
          >
            <strong>Total</strong>
          </td>
          <td
            style="
              border-top: 1px solid #dbdbdb;
              border-bottom: 1px solid #dbdbdb;
              padding: 2px;
              text-align: right;
            "
          >
            <strong>{{ totales.total.sinicial | number(2) }}</strong>
          </td>
          <td
            style="
              border-top: 1px solid #dbdbdb;
              border-bottom: 1px solid #dbdbdb;
              padding: 2px;
              text-align: right;
            "
          >
            <strong>{{ totales.total.debito | number(2) }}</strong>
          </td>
          <td
            style="
              border-top: 1px solid #dbdbdb;
              border-bottom: 1px solid #dbdbdb;
              padding: 2px;
              text-align: right;
            "
          >
            <strong>{{ totales.total.credito | number(2) }}</strong>
          </td>
          <td
            style="
              border-top: 1px solid #dbdbdb;
              border-bottom: 1px solid #dbdbdb;
              padding: 2px;
              text-align: right;
            "
          >
            <strong>{{ totales.total.sfinal | number(2) }}</strong>
          </td>
        </tr>
      </table>
    </div>
    <y-saldomodalbalance
      :show="showmodalsaldobalance"
      :saldoaux="saldoaux"
      :cuentaselected="cuentaselected"
      :periodo="periodo"
      :period="period"
      @showmodalsbalance="showmodalsbalance"
      @selectperiod="periodselected"
    ></y-saldomodalbalance>
  </div>
</template>

<script>
import apiServices from "@/services/yungol-services";
import yPeriodselector from "@/components/commons/PeriodselectorV2.vue";
import ySaldomodalbalance from "@/components/modals/SaldoModalBalance.vue";
import { mapState } from "vuex";
const XLSX = require("xlsx");
export default {
  data() {
    return {
      showmodalsaldobalance: false,
      cuentaselected: {
        nombre: "",
        codigo: "",
        _id: "",
        dctoref: false,
      },
      ccostos: [],
      yearanterior: null,
      showBalance: false,
      period: {
        year: null,
        months: null,
      },
      ccosto: "",
      balance: null,
      saldo: null,
      movimiento: null,
      auxsaldo: null,
      auxmovimiento: null,
      cuentas: null,
      cuentasclasificadas: null,
      totales: {
        grupo: {
          list: [],
        },
        subGrupo: {
          list: [],
        },
        subCuenta: {
          list: [],
        },
        sSubCuenta: {
          list: [],
        },
        cuenta: {
          list: [],
        },
        todas: {
          list: [],
        },
        total: {
          sinicial: 0,
          debito: 0,
          credito: 0,
          sfinal: 0,
        },
      },
      saldoaux: {
        list: [],
        total: {
          sinicial: 0,
          debito: 0,
          credito: 0,
          sfinal: 0,
        },
        listnits: [],
        objectnits: {},
      },
      hoverbalance: {
        codigo: null,
        lugar: null,
      },
      data2export: [],
    };
  },
  computed: {
    ...mapState(["empresa", "nits"]),
    periodo() {
      const year = this.period.year;
      let month = this.period.months[0];
      month = month.toString();
      if (month.length === 1) {
        month = `0${month}`;
      }
      return `${year}${month}`;
    },
    nccosto() {
      let ncosto = "";
      const _this = this;
      for (let index = 0; index < this.ccostos.length; index++) {
        const ccosto = _this.ccostos[index];
        if (ccosto.codigo === _this.ccosto) {
          ncosto = ccosto.nombre;
        }
      }
      return ncosto;
    },
  },
  methods: {
    decimals(number) {
      let entero = parseInt(number * 100);
      entero = parseFloat(entero / 100);
      return entero;
    },
    descargarBalance() {
      const indexCta = this.totales.todas.list.length;
      for (let cta = 0; cta < indexCta; cta++) {
        const data2push = {
          Codigo: this.totales.todas.list[cta],
          Nombre: this.totales[
            this.totales.todas[this.totales.todas.list[cta]]
          ][this.totales.todas.list[cta]].nombre,
          S_Inicial: this.totales[
            this.totales.todas[this.totales.todas.list[cta]]
          ][this.totales.todas.list[cta]].sinicial,
          Debito: this.totales[
            this.totales.todas[this.totales.todas.list[cta]]
          ][this.totales.todas.list[cta]].debito,
          Credito: this.totales[
            this.totales.todas[this.totales.todas.list[cta]]
          ][this.totales.todas.list[cta]].credito,
          S_Final: this.totales[
            this.totales.todas[this.totales.todas.list[cta]]
          ][this.totales.todas.list[cta]].sfinal,
        };
        this.data2export.push(data2push);
      }

      const data2pushTotal = {
        // aqui se totaliza para que no muestre todos esos decimales
        Codigo: "T",
        Nombre: "Total",
        S_Inicial: this.decimals(this.totales.total.sinicial),
        Debito: this.decimals(this.totales.total.debito),
        Credito: this.decimals(this.totales.total.credito),
        S_Final: this.decimals(this.totales.total.sfinal),
      };
      this.data2export.push(data2pushTotal);

      let data = XLSX.utils.json_to_sheet(this.data2export);
      const workbook = XLSX.utils.book_new();
      const filename = "Balance de cuenta " + this.periodo;
      XLSX.utils.book_append_sheet(workbook, data, filename);
      XLSX.writeFile(workbook, `${filename}.xlsx`);

      this.data2export = [];
    },
    showmodalsbalance(payload) {
      this.showmodalsaldobalance = payload;
    },
    async auxiliar(cuenta, lugar) {
      try {
        const _this = this;
        this.cuentaselected.codigo = cuenta;
        this.cuentaselected.nombre =
          _this.cuentasclasificadas.cuenta[cuenta].nombre;
        this.cuentaselected._id = _this.cuentasclasificadas.cuenta[cuenta]._id;
        this.cuentaselected.dctoref =
          _this.cuentasclasificadas.cuenta[cuenta].dctoref;
        const query = {
          period: _this.period,
          cuenta: _this.cuentasclasificadas.cuenta[cuenta]._id,
        };
        let result;
        result = await apiServices.post(`/saldocuenta`, query);
        this.auxsaldo = result.data.saldo;
        this.auxmovimiento = result.data.movimiento;
        this.transformDataSaldo();
        this.showmodalsaldobalance = true;
      } catch (err) {
        console.log(err);
      }
    },
    changeccosto() {
      this.transformData();
    },
    imprimir() {
      // functions.imprimir(this.data.comprobante.nombre,this.data.documento,this.data.mes.codigo);
      this.$print("printbalance", {
        name: `Balance de cuenta ${this.empresa.nombrec} ${this.empresa.nit} ${this.periodo}`,
      });
    },
    leavecuenta() {
      this.hoverbalance.codigo = null;
      this.hoverbalance.lugar = null;
    },
    hovercuenta(codigo, lugar) {
      if (this.totales.todas[codigo] === "cuenta") {
        this.hoverbalance.codigo = codigo;
        this.hoverbalance.lugar = lugar;
      }
    },
    styleTr(codigo, lugar) {
      if (this.totales.todas[codigo] === "grupo") {
        return {
          "padding-top": "30px",
          "font-weight": "bold",
          "border-bottom": "1px solid #dbdbdb",
          color: "black",
        };
      }
      if (this.totales.todas[codigo] === "subGrupo") {
        return {
          "padding-top": "15px",
          "font-weight": "bold",
          color: "black",
        };
      }
      if (this.totales.todas[codigo] === "subCuenta") {
        return {
          "padding-top": "15px",
          "font-weight": "bold",
        };
      }
      if (this.totales.todas[codigo] === "cuenta") {
        if (
          lugar &&
          this.hoverbalance.codigo === codigo &&
          this.hoverbalance.lugar === lugar
        ) {
          return { color: "blue", cursor: "pointer" };
        } else {
          return {
            color: "#adadad",
          };
        }
      }
    },
    transformDataSaldo() {
      if (this.auxsaldo) {
        const saldo = this.auxsaldo;
        const movimiento = this.auxmovimiento;
        const _this = this;
        const saldosorganizados = {
          list: [],
        };
        this.saldoaux = {
          list: [],
          total: {
            sinicial: 0,
            debito: 0,
            credito: 0,
            sfinal: 0,
          },
          listnits: [],
          objectnits: {},
        };
        // con esto organizamos los saldos para poner en anterior el saldo inicial
        for (let index = 0; index < saldo.length; index++) {
          const reg = saldo[index];
          let filtrocccosto = false;
          if (this.ccosto === "") {
            filtrocccosto = true;
          } else if (this.ccosto === reg._id.ccostos) {
            filtrocccosto = true;
          } else {
            filtrocccosto = false;
          }
          if (filtrocccosto) {
            if (
              saldosorganizados.list.indexOf(
                `${reg._id.idnit}-D-${reg._id.docRef}`
              ) === -1
            ) {
              saldosorganizados.list.push(
                `${reg._id.idnit}-D-${reg._id.docRef}`
              );
              saldosorganizados[`${reg._id.idnit}-D-${reg._id.docRef}`] = {
                mes: [],
                idnit: reg._id.idnit,
                docRef: reg._id.docRef,
                actual: 0,
                anterior: 0,
                debito: 0,
                credito: 0,
              };
            }
            saldosorganizados[`${reg._id.idnit}-D-${reg._id.docRef}`].actual +=
              reg._id.year === _this.period.year ? reg.valor : 0;
            saldosorganizados[
              `${reg._id.idnit}-D-${reg._id.docRef}`
            ].anterior += reg._id.year < _this.period.year ? reg.valor : 0;
            if (reg._id.year < _this.period.year && reg.valor !== 0) {
              saldosorganizados[
                `${reg._id.idnit}-D-${reg._id.docRef}`
              ].mes.push(99);
            }
          }
        }
        // con esto le agregamos el debito el credito del movimiento y en saldo anterior ponemos los movimientos de los meses anteriores al que esta mostrando en pantalla
        for (let index1 = 0; index1 < movimiento.length; index1++) {
          const reg = movimiento[index1];
          let filtrocccosto = false;
          if (this.ccosto === "") {
            filtrocccosto = true;
          } else if (this.ccosto === reg.ccostos) {
            filtrocccosto = true;
          } else {
            filtrocccosto = false;
          }
          if (filtrocccosto) {
            saldosorganizados[`${reg.idnit}-D-${reg.docRef}`].debito +=
              reg[_this.period.months[0]].debito;
            saldosorganizados[`${reg.idnit}-D-${reg.docRef}`].credito +=
              reg[_this.period.months[0]].credito;
            for (let ind = 1; ind < 14; ind++) {
              if (ind < _this.period.months[0]) {
                saldosorganizados[`${reg.idnit}-D-${reg.docRef}`].anterior +=
                  reg[ind].valor;
                if (reg[ind].valor !== 0) {
                  saldosorganizados[`${reg.idnit}-D-${reg.docRef}`].mes.push(
                    ind
                  );
                }
              }
            }
          }
        }
        for (let index = 0; index < saldosorganizados.list.length; index++) {
          const item = saldosorganizados.list[index];
          if (
            saldosorganizados[item].anterior !== 0 ||
            saldosorganizados[item].debito !== 0 ||
            saldosorganizados[item].credito !== 0
          ) {
            const dato = {
              idnit: saldosorganizados[item].idnit,
              mes: saldosorganizados[item].mes,
              docRef: saldosorganizados[item].docRef,
              sinicial: saldosorganizados[item].anterior,
              debito: saldosorganizados[item].debito,
              credito: saldosorganizados[item].credito,
              sfinal:
                saldosorganizados[item].anterior +
                saldosorganizados[item].debito -
                saldosorganizados[item].credito,
            };
            _this.saldoaux.total.sinicial += dato.sinicial;
            _this.saldoaux.total.debito += dato.debito;
            _this.saldoaux.total.credito += dato.credito;
            _this.saldoaux.total.sfinal += dato.sfinal;
            _this.saldoaux.list.push(item);
            _this.saldoaux[item] = dato;
            if (
              _this.saldoaux.list.indexOf(
                `${saldosorganizados[item].idnit}-T`
              ) === -1
            ) {
              _this.saldoaux.list.push(`${saldosorganizados[item].idnit}-T`);
              _this.saldoaux[`${saldosorganizados[item].idnit}-T`] = {
                isTotal: true,
                idnit: saldosorganizados[item].idnit,
                sinicial: 0,
                debito: 0,
                credito: 0,
                sfinal: 0,
              };
            }
            _this.saldoaux[`${saldosorganizados[item].idnit}-T`].sinicial +=
              dato.sinicial;
            _this.saldoaux[`${saldosorganizados[item].idnit}-T`].debito +=
              dato.debito;
            _this.saldoaux[`${saldosorganizados[item].idnit}-T`].credito +=
              dato.credito;
            _this.saldoaux[`${saldosorganizados[item].idnit}-T`].sfinal +=
              dato.sfinal;
          }
        }
        for (let index = 0; index < _this.nits.length; index++) {
          _this.saldoaux.objectnits[_this.nits[index]._id] = _this.nits[index];
        }
        _this.saldoaux.list.sort();
      }
    },
    transformData() {
      const saldo = this.saldo;
      const movimiento = this.movimiento;
      const cuentas = this.cuentas;
      const _this = this;
      const saldosorganizados = {
        cuentas: [],
      };
      _this.totales = {
        grupo: {
          list: [],
        },
        subGrupo: {
          list: [],
        },
        subCuenta: {
          list: [],
        },
        sSubCuenta: {
          list: [],
        },
        cuenta: {
          list: [],
        },
        todas: {
          list: [],
        },
        total: {
          sinicial: 0,
          debito: 0,
          credito: 0,
          sfinal: 0,
        },
      };
      for (let index = 0; index < saldo.length; index++) {
        const reg = saldo[index];
        let filtrocccosto = false;
        if (this.ccosto === "") {
          filtrocccosto = true;
        } else if (this.ccosto === reg._id.ccostos) {
          filtrocccosto = true;
        } else {
          filtrocccosto = false;
        }
        if (filtrocccosto) {
          if (saldosorganizados.cuentas.indexOf(reg._id.idcuenta) === -1) {
            saldosorganizados.cuentas.push(reg._id.idcuenta);
            saldosorganizados[reg._id.idcuenta] = {
              actual: 0,
              anterior: 0,
              debito: 0,
              credito: 0,
            };
            saldosorganizados[reg._id.idcuenta].actual +=
              reg._id.year === _this.period.year ? reg.valor : 0;
            saldosorganizados[reg._id.idcuenta].anterior +=
              reg._id.year < _this.period.year ? reg.valor : 0;
          } else {
            saldosorganizados[reg._id.idcuenta].actual +=
              reg._id.year === _this.period.year ? reg.valor : 0;
            saldosorganizados[reg._id.idcuenta].anterior +=
              reg._id.year < _this.period.year ? reg.valor : 0;
          }
        }
      }
      for (let index1 = 0; index1 < movimiento.length; index1++) {
        const reg = movimiento[index1];
        let filtrocccosto = false;
        if (this.ccosto === "") {
          filtrocccosto = true;
        } else if (this.ccosto === reg.ccostos) {
          filtrocccosto = true;
        } else {
          filtrocccosto = false;
        }
        if (filtrocccosto) {
          saldosorganizados[reg.cuenta].debito +=
            reg[_this.period.months[0]].debito;
          saldosorganizados[reg.cuenta].credito +=
            reg[_this.period.months[0]].credito;
          for (let ind = 1; ind < 14; ind++) {
            if (ind < _this.period.months[0]) {
              saldosorganizados[reg.cuenta].anterior += reg[ind].valor;
            }
          }
        }
      }
      _this.cuentasclasificadas = {
        grupo: {},
        subGrupo: {},
        subCuenta: {},
        sSubCuenta: {},
        cuenta: {},
      };
      for (let index = 0; index < cuentas.length; index++) {
        const cuenta = cuentas[index];
        if (saldosorganizados[cuenta._id]) {
          saldosorganizados[cuenta._id].detalle = cuenta;
        }
        if (cuenta.codigo.length === 1) {
          _this.cuentasclasificadas.grupo[cuenta.codigo] = cuenta;
        } else if (cuenta.codigo.length === 2) {
          _this.cuentasclasificadas.subGrupo[cuenta.codigo] = cuenta;
        } else if (cuenta.codigo.length === 4) {
          _this.cuentasclasificadas.subCuenta[cuenta.codigo] = cuenta;
        } else if (cuenta.codigo.length === 6) {
          _this.cuentasclasificadas.sSubCuenta[cuenta.codigo] = cuenta;
        }
        if (cuenta.esRegistro) {
          _this.cuentasclasificadas.cuenta[cuenta.codigo] = cuenta;
        }
      }
      for (let index = 0; index < saldosorganizados.cuentas.length; index++) {
        const idcuenta = saldosorganizados.cuentas[index];
        const dato = {
          idcuenta: idcuenta,
          sinicial: saldosorganizados[idcuenta].anterior,
          debito: saldosorganizados[idcuenta].debito,
          credito: saldosorganizados[idcuenta].credito,
          sfinal:
            saldosorganizados[idcuenta].anterior +
            saldosorganizados[idcuenta].debito -
            saldosorganizados[idcuenta].credito,
        };
        if (
          saldosorganizados[idcuenta].anterior !== 0 ||
          saldosorganizados[idcuenta].debito !== 0 ||
          saldosorganizados[idcuenta].credito !== 0
        ) {
          // se conforman los grupos
          if (
            this.totales.grupo.list.indexOf(
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 1)
            ) === -1
          ) {
            _this.totales.grupo.list.push(
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 1)
            );
            _this.totales.todas.list.push(
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 1)
            );
            _this.totales.todas[
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 1)
            ] = "grupo";
            _this.totales.grupo[
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 1)
            ] = {
              nombre:
                _this.cuentasclasificadas.grupo[
                  saldosorganizados[idcuenta].detalle.codigo.substr(0, 1)
                ].nombre,
              estructura: "grupo",
              debito: 0,
              credito: 0,
              sinicial: 0,
              sfinal: 0,
              subGrupo: [],
            };
            _this.totales.grupo[
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 1)
            ].debito += dato.debito;
            _this.totales.grupo[
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 1)
            ].credito += dato.credito;
            _this.totales.grupo[
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 1)
            ].sinicial += dato.sinicial;
            _this.totales.grupo[
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 1)
            ].sfinal += dato.sfinal;
          } else {
            _this.totales.grupo[
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 1)
            ].debito += dato.debito;
            _this.totales.grupo[
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 1)
            ].credito += dato.credito;
            _this.totales.grupo[
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 1)
            ].sinicial += dato.sinicial;
            _this.totales.grupo[
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 1)
            ].sfinal += dato.sfinal;
          }
          // se consforman los subGgupos
          if (
            this.totales.subGrupo.list.indexOf(
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 2)
            ) === -1
          ) {
            _this.totales.subGrupo.list.push(
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 2)
            );
            _this.totales.todas.list.push(
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 2)
            );
            _this.totales.todas[
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 2)
            ] = "subGrupo";
            _this.totales.subGrupo[
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 2)
            ] = {
              nombre:
                _this.cuentasclasificadas.subGrupo[
                  saldosorganizados[idcuenta].detalle.codigo.substr(0, 2)
                ].nombre,
              estructura: "subGrupo",
              debito: 0,
              credito: 0,
              sinicial: 0,
              sfinal: 0,
              subCuenta: [],
            };
            _this.totales.subGrupo[
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 2)
            ].debito += dato.debito;
            _this.totales.subGrupo[
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 2)
            ].credito += dato.credito;
            _this.totales.subGrupo[
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 2)
            ].sinicial += dato.sinicial;
            _this.totales.subGrupo[
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 2)
            ].sfinal += dato.sfinal;
          } else {
            _this.totales.subGrupo[
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 2)
            ].debito += dato.debito;
            _this.totales.subGrupo[
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 2)
            ].credito += dato.credito;
            _this.totales.subGrupo[
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 2)
            ].sinicial += dato.sinicial;
            _this.totales.subGrupo[
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 2)
            ].sfinal += dato.sfinal;
          }
          // se conforman los subCuentas
          if (
            this.totales.subCuenta.list.indexOf(
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 4)
            ) === -1
          ) {
            _this.totales.subCuenta.list.push(
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 4)
            );
            _this.totales.todas.list.push(
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 4)
            );
            _this.totales.todas[
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 4)
            ] = "subCuenta";
            _this.totales.subCuenta[
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 4)
            ] = {
              nombre:
                _this.cuentasclasificadas.subCuenta[
                  saldosorganizados[idcuenta].detalle.codigo.substr(0, 4)
                ].nombre,
              estructura: "subCuenta",
              debito: 0,
              credito: 0,
              sinicial: 0,
              sfinal: 0,
              sSubCuenta: [],
            };
            _this.totales.subCuenta[
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 4)
            ].debito += dato.debito;
            _this.totales.subCuenta[
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 4)
            ].credito += dato.credito;
            _this.totales.subCuenta[
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 4)
            ].sinicial += dato.sinicial;
            _this.totales.subCuenta[
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 4)
            ].sfinal += dato.sfinal;
          } else {
            _this.totales.subCuenta[
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 4)
            ].debito += dato.debito;
            _this.totales.subCuenta[
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 4)
            ].credito += dato.credito;
            _this.totales.subCuenta[
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 4)
            ].sinicial += dato.sinicial;
            _this.totales.subCuenta[
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 4)
            ].sfinal += dato.sfinal;
          }
          // se conforman las sSubCuenta
          if (
            this.totales.sSubCuenta.list.indexOf(
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 6)
            ) === -1
          ) {
            _this.totales.sSubCuenta.list.push(
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 6)
            );
            _this.totales.todas.list.push(
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 6)
            );
            _this.totales.todas[
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 6)
            ] = "sSubCuenta";
            _this.totales.sSubCuenta[
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 6)
            ] = {
              nombre:
                _this.cuentasclasificadas.sSubCuenta[
                  saldosorganizados[idcuenta].detalle.codigo.substr(0, 6)
                ].nombre,
              esctructura: "sSubCuenta",
              debito: 0,
              credito: 0,
              sinicial: 0,
              sfinal: 0,
              cuenta: [],
              detalle:
                _this.cuentasclasificadas.sSubCuenta[
                  saldosorganizados[idcuenta].detalle.codigo.substr(0, 6)
                ],
            };
            _this.totales.sSubCuenta[
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 6)
            ].debito += dato.debito;
            _this.totales.sSubCuenta[
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 6)
            ].credito += dato.credito;
            _this.totales.sSubCuenta[
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 6)
            ].sinicial += dato.sinicial;
            _this.totales.sSubCuenta[
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 6)
            ].sfinal += dato.sfinal;
          } else {
            _this.totales.sSubCuenta[
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 6)
            ].debito += dato.debito;
            _this.totales.sSubCuenta[
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 6)
            ].credito += dato.credito;
            _this.totales.sSubCuenta[
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 6)
            ].sinicial += dato.sinicial;
            _this.totales.sSubCuenta[
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 6)
            ].sfinal += dato.sfinal;
          }
          // se conforman las cuentas
          if (
            this.totales.cuenta.list.indexOf(
              saldosorganizados[idcuenta].detalle.codigo
            ) === -1
          ) {
            _this.totales.cuenta.list.push(
              saldosorganizados[idcuenta].detalle.codigo
            );
            // si no funciona tocara poner un codigo para que no repita la lista de cuentas
            _this.totales.todas.list.push(
              saldosorganizados[idcuenta].detalle.codigo
            );
            _this.totales.todas[saldosorganizados[idcuenta].detalle.codigo] =
              "cuenta";
            _this.totales.cuenta[saldosorganizados[idcuenta].detalle.codigo] = {
              nombre: _this.cuentasclasificadas.cuenta[
                saldosorganizados[idcuenta].detalle.codigo
              ]
                ? _this.cuentasclasificadas.cuenta[
                    saldosorganizados[idcuenta].detalle.codigo
                  ].nombre
                : _this.cuentasclasificadas.sSubCuenta[
                    saldosorganizados[idcuenta].detalle.codigo
                  ].nombre,
              estructura: "cuenta",
              debito: 0,
              credito: 0,
              sinicial: 0,
              sfinal: 0,
              detalle: saldosorganizados[idcuenta].detalle,
            };
            _this.totales.cuenta[
              saldosorganizados[idcuenta].detalle.codigo
            ].debito += dato.debito;
            _this.totales.cuenta[
              saldosorganizados[idcuenta].detalle.codigo
            ].credito += dato.credito;
            _this.totales.cuenta[
              saldosorganizados[idcuenta].detalle.codigo
            ].sinicial += dato.sinicial;
            _this.totales.cuenta[
              saldosorganizados[idcuenta].detalle.codigo
            ].sfinal += dato.sfinal;
          } else {
            _this.totales.cuenta[
              saldosorganizados[idcuenta].detalle.codigo
            ].debito += dato.debito;
            _this.totales.cuenta[
              saldosorganizados[idcuenta].detalle.codigo
            ].credito += dato.credito;
            _this.totales.cuenta[
              saldosorganizados[idcuenta].detalle.codigo
            ].sinicial += dato.sinicial;
            _this.totales.cuenta[
              saldosorganizados[idcuenta].detalle.codigo
            ].sfinal += dato.sfinal;
          }
          // con esto se agrega los subgrupos a los grupos
          if (
            _this.totales.grupo[
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 1)
            ].subGrupo.indexOf(
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 2)
            ) === -1
          ) {
            _this.totales.grupo[
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 1)
            ].subGrupo.push(
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 2)
            );
          }
          // con esto se agrega la subCuenta a los subGrupos
          if (
            _this.totales.subGrupo[
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 2)
            ].subCuenta.indexOf(
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 4)
            ) === -1
          ) {
            _this.totales.subGrupo[
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 2)
            ].subCuenta.push(
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 4)
            );
          }
          // con esto se agrega la sSubCuenta a la subCuenta
          if (
            _this.totales.subCuenta[
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 4)
            ].sSubCuenta.indexOf(
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 6)
            ) === -1
          ) {
            _this.totales.subCuenta[
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 4)
            ].sSubCuenta.push(
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 6)
            );
          }
          // con esto se agrega la cuentas a las sSubCuenta
          if (
            _this.totales.sSubCuenta[
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 6)
            ].cuenta.indexOf(saldosorganizados[idcuenta].detalle.codigo) === -1
          ) {
            _this.totales.sSubCuenta[
              saldosorganizados[idcuenta].detalle.codigo.substr(0, 6)
            ].cuenta.push(saldosorganizados[idcuenta].detalle.codigo);
          }
          // con esto totaliza
          _this.totales.total.sinicial += dato.sinicial;
          _this.totales.total.debito += dato.debito;
          _this.totales.total.credito += dato.credito;
          _this.totales.total.sfinal += dato.sfinal;
        }
      }
      function onlyUnique(value, index, self) {
        return self.indexOf(value) === index;
      }

      _this.totales.todas.list = _this.totales.todas.list.filter(onlyUnique);

      _this.totales.todas.list.sort();
      // // se ordenan los subgrupos
      // for (let index = 0; index < _this.totales.grupo.list.length; index++) {
      //   const grupo = _this.totales.grupo.list[index];
      //   _this.totales.grupo[grupo].subGrupo.sort();
      // }
      // // se ordenan las subcuentas
      // for (let index = 0; index < _this.totales.subGrupo.list.length; index++) {
      //   const subGrupo = _this.totales.subGrupo.list[index];
      //   _this.totales.subGrupo[subGrupo].subCuenta.sort();
      // }
      // // se ordenan las sSubCuentas
      // for (
      //   let index = 0;
      //   index < _this.totales.subCuenta.list.length;
      //   index++
      // ) {
      //   const subCuenta = _this.totales.subCuenta.list[index];
      //   _this.totales.subCuenta[subCuenta].sSubCuenta.sort();
      // }
    },
    async search() {
      try {
        const _this = this;
        const query = {
          period: this.period,
          ccosto: this.ccosto,
        };
        let result;
        result = await apiServices.post(`/balance`, query);
        if (result.data && result.data.saldo.length > 0) {
          _this.saldo = result.data.saldo;
          _this.movimiento = result.data.movimiento;
          _this.cuentas = result.data.cuentas;
          _this.yearanterior = _this.period.year;
        }
        _this.transformData();
      } catch (err) {
        console.log(err);
      }
    },
    async preparar() {
      try {
        // const result = await apiServices.post(`/balance`,query);
        const result = await apiServices.get(`/processdatabalance`);
        this.balance = result.data;
        if (result.data) {
          this.prepararauxiliar();
        }
      } catch (err) {
        console.log(err);
      }
    },
    async prepararauxiliar() {
      try {
        // const result = await apiServices.post(`/balance`,query);
        const result = await apiServices.get(`/processdataauxiliar`);
        if (result.data) {
          console.log(result.data);
        }
      } catch (err) {
        console.log(err);
      }
    },
    periodselected(period) {
      this.period = period;
    },
    async getccostos() {
      const _this = this;
      const result = await apiServices.get(`/ccostos`);
      this.ccostos = [
        {
          codigo: "",
          nombre: "Centro de Costos",
        },
      ];
      for (let index in result.data) {
        _this.ccostos.push(result.data[index]);
      }
    },
    searchBalance() {
      this.showBalance = true;
    },
    cancel() {
      this.showBalance = false;
    },
  },
  created() {
    this.getccostos();
    const today = new Date();
    this.period.year = today.getFullYear();
    this.period.months = [today.getMonth() + 1];
  },
  watch: {
    period(nv, ov) {
      if (nv.year !== ov.year) {
        this.search();
      } else {
        if (this.saldo) {
          this.transformData();
          this.transformDataSaldo();
        }
      }
    },
  },
  components: {
    yPeriodselector,
    ySaldomodalbalance,
  },
};
</script>


// WEBPACK FOOTER //
// src/components/reports/accountbalance/Accountbalance.vue